import {
  Boundary,
  DrawerSize,
  Icon,
  Menu,
  MenuItem,
  Position,
} from "@blueprintjs/core"
import CustomPopover from "components/Atoms/CustomPopover"
import useAuth from "hooks/useAuth"
import useAuthorizationStrict from "hooks/useAuthorizationStrict"
import { startCase } from "lodash-es"
import React, { useCallback, useState } from "react"
import { getApolloId } from "utils/custom.utils"
import CustomButton from "../../Atoms/CustomButton"
import CustomDrawer from "../../Atoms/CustomDrawer"
import CustomTag from "../../Atoms/CustomTag"
import CustomOverflowList from "../../Molecules/CustomOverflowList"
import AppVersion from "./AppVersion"
import ChangePasswordModal from "./ChangePasswordModal"
import MasterOtp from "./MasterOtp"
export default function UserProfile() {
  const canViewOtp = useAuthorizationStrict(["vt_can_view_master_otp"])

  const [isOpen, toggleOpen] = useState(false)
  const [isModalOpen, toggleModel] = useState(false)
  const { user, logout } = useAuth()

  const handleDrawerToggle = useCallback(
    () => toggleOpen(isOpen => !isOpen),
    [toggleOpen]
  )

  const handleLogout = useCallback(() => logout(), [logout])

  if (!user) return null
  return (
    <>
      <CustomButton
        data-testid="user-profile-button"
        className="ml-3"
        icon="user"
        text={user.fullName}
        onClick={handleDrawerToggle}
      />
      <CustomDrawer
        className="vt-user-profile-drawer"
        size={DrawerSize.SMALL}
        isOpen={isOpen}
        hasBackdrop={false}
        toggleOpen={handleDrawerToggle}
        onClose={handleDrawerToggle}
      >
        <CustomButton
          onClick={handleDrawerToggle}
          icon="cross"
          minimal
          className="vt-close-button"
        />
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-3">
            <div className="vt-user-img">
              <img src={user.photo} alt="" />
            </div>
          </div>
          <div className="col-span-9 flex flex-col justify-between">
            <div>
              <p className="vt-user-name">
                {startCase(user.fullName)}{" "}
                {user.isSuperadmin && (
                  <CustomTag
                    className="pl-0"
                    icon={<Icon className="ml-2" icon="star" iconSize={10} />}
                    minimal
                    round
                    intent="success"
                  >
                    Admin
                  </CustomTag>
                )}
              </p>
            </div>
            <div className="vt-user-details">
              <p className="vt-user-phone">{user.number}</p>
              <p>{user.email}</p>
            </div>
            <div className="mt-3">
              <div className="w-full flex text-sm italic mr-2">
                <span className="mr-3">Groups</span>
                <CustomOverflowList
                  items={user.groups}
                  collapseFrom={Boundary.END}
                  visibleItemRenderer={item => (
                    <div>
                      <CustomTag
                        key={getApolloId(item)}
                        className="mr-2 vt-profile-group-selector"
                        intent="primary"
                      >
                        {item.name}
                      </CustomTag>
                    </div>
                  )}
                  overflowRenderer={items => {
                    return (
                      <CustomPopover
                        minimal
                        position={Position.BOTTOM_LEFT}
                        content={
                          <Menu
                            style={{
                              fontSize: 14,
                              width: 120,
                              height: 180,
                              overflowY: "scroll",
                            }}
                          >
                            {items.map(g => (
                              <MenuItem
                                key={getApolloId(g)}
                                text={g.name}
                                icon="people"
                              />
                            ))}
                          </Menu>
                        }
                      >
                        <CustomTag
                          className="mr-2 vt-profile-group-selector"
                          intent="primary"
                          minimal
                        >
                          + {items.length}
                        </CustomTag>
                      </CustomPopover>
                    )
                  }}
                ></CustomOverflowList>
              </div>

              <div
                onClick={handleLogout}
                style={{
                  cursor: "pointer",
                  display: "inline-block",
                }}
                className="text-sm vt-highlight vt-styled-link vt-styled-link-text mt-3"
              >
                Logout
              </div>
              <div
                onClick={e => toggleModel(true)}
                style={{
                  cursor: "pointer",
                  display: "inline-block",
                }}
                className="text-sm ml-3 mt-3 italic"
              >
                Change Password?
              </div>
            </div>
          </div>
        </div>
        <hr />

        {canViewOtp && <MasterOtp />}

        <AppVersion />
      </CustomDrawer>
      <ChangePasswordModal
        isOpen={isModalOpen}
        onClose={e => toggleModel(false)}
      />
    </>
  )
}
